import { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { FiChevronLeft } from 'react-icons/fi'
import { FiChevronRight } from 'react-icons/fi'
import { FiChevronDown } from 'react-icons/fi'
import PlaceHolder from 'components/PlaceHolder/PlaceHolder'
import hintArrow from './images/hint-arrow.svg'
import hintArrowYellow from './images/hint-arrow-yellow.svg'
import RangeSlider from 'react-bootstrap-range-slider'
import { useLocalStorage } from 'usehooks-ts'
import 'bootstrap/dist/css/bootstrap.css' // or include from a CDN
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css'
// import './styles.scss'

const avatarCount = 10
const avatarIDs = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
let preloadedImages: any[]

// a component with props tenant and colorMode
const AgeInput = ({
  tenant,
  colorMode,
}: {
  tenant?: Object
  colorMode?: String
}) => {
  //
  const [birthYear, setBirthYear] = useState(-1)
  const [birthYearChosen, setBirthYearChosen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [avatarId, setAvatarId] = useLocalStorage(
    'avatarId',
    Math.floor(Math.random() * avatarCount)
  )
  const [chooserWidth, setChooserWidth] = useState(0)
  const chooserRef = useRef<any>()
  const [avatarChosen, setAvatarChosen] = useLocalStorage('avatarChosen', false)
  const [sliderLeft, setSliderLeft] = useState(0)
  const sliderRef = useRef<any>()
  const [sliderUsed, setSliderUsed] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
    setChooserWidth(chooserRef.current ? chooserRef.current.offsetWidth : 0)
    setSliderLeft(sliderRef.current ? sliderRef.current.offsetLeft : 0)
  }

  useEffect(() => {
    preloadedImages = avatarIDs.map(function (id) {
      return (
        <img
          src={require('../../images/avatar/' + id + '.png')}
          alt='preload'
        />
      )
    })

    const localYear = localStorage.getItem('birthYear')
    localYear ? setBirthYear(parseInt(localYear)) : setBirthYear(-1)
    localYear ? setBirthYearChosen(true) : setBirthYearChosen(false)

    avatarChosen
      ? setAvatarChosen(true)
      : setAvatarId(Math.floor(Math.random() * avatarCount))

    setChooserWidth(chooserRef.current ? chooserRef.current.offsetWidth : 0)
    setSliderLeft(sliderRef.current ? sliderRef.current.offsetLeft : 0)

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // function that sets the value of the slider to the state variable
  const changeValue = (newValue: number) => {
    // console.log('changeValue:', newValue)
    !avatarChosen && setAvatarId(Math.floor(Math.random() * avatarCount))
    setBirthYear(newValue)
    setSliderUsed(true)
  }

  const setValue = (newValue: number) => {
    localStorage.setItem('birthYear', newValue.toString())
    setBirthYearChosen(true)
    const setBirthyear = new CustomEvent('userBirthyear', {
      detail: newValue,
    })
    window.dispatchEvent(setBirthyear)
  }

  // function that counts up avatarId until it reaches the last avatar and then starts again at the first
  const nextAvatar = () => {
    setAvatarChosen(true)
    if (avatarId < avatarCount - 1) {
      setAvatarId(avatarId + 1)
    } else {
      setAvatarId(0)
    }
  }

  const prevAvatar = () => {
    setAvatarChosen(true)
    if (avatarId > 0) {
      setAvatarId(avatarId - 1)
    } else {
      setAvatarId(avatarCount - 1)
    }
  }

  return (
    <AgeSlider>
      <div style={{ display: 'none' }}>{preloadedImages}</div>
      <div className='slider-wrapper'>
        <h3>
          In welchem Jahr
          <br />
          wurden Sie geboren?
        </h3>
        <div className='avatar-chooser' ref={chooserRef}>
          <div className='prev' onClick={prevAvatar}>
            <FiChevronLeft />
          </div>
          <img
            className='avatar'
            alt='avatar'
            src={require('../../images/avatar/' + avatarId + '.png')}
            onClick={nextAvatar}
          />
          <div className='next' onClick={nextAvatar}>
            <FiChevronRight />
          </div>
          {/* !avatarChosen && (
            <AvatarHint
              style={{
                marginLeft:
                  window.innerWidth > 400
                    ? chooserWidth / 5 + 'px'
                    : chooserWidth / 4 + 'px',
              }}
            >
              <div>Avatar wählen</div>
              <img
                src={colorMode === 'dark' ? hintArrowYellow : hintArrow}
                alt='hint'
              />
            </AvatarHint>
            ) */}
        </div>
        {!birthYearChosen && !sliderUsed && (
          <YearHint style={{ left: sliderLeft }}>
            <img
              src={colorMode === 'dark' ? hintArrowYellow : hintArrow}
              alt='hint'
            />
            <div>Jahr wählen</div>
          </YearHint>
        )}
        <div className='sliderWrapper' ref={sliderRef}>
          <RangeSlider
            // https://jaywilz.github.io/react-bootstrap-range-slider
            value={birthYear}
            min={1925}
            max={2015}
            onChange={(e) => changeValue(parseInt(e.target.value))}
            onAfterChange={(e) => setValue(parseInt(e.target.value))}
            tooltip='off'
            size='lg'
          />
          {birthYear > 0 && <div className='displayer'>{birthYear}</div>}
        </div>
      </div>
      {!birthYearChosen && <PlaceHolder />}
      {birthYearChosen && (
        <ScrollHint>
          <p>Bitte scrollen</p>
          <FiChevronDown />
        </ScrollHint>
      )}
    </AgeSlider>
  )
}
const AgeSlider = styled.div`
  text-align: center;
  font-family: var(--font-sans-serif);
  font-size: 1.6rem;
  padding: 3rem 0;
  @media only screen and (max-width: 600px) {
    padding: 0;
  }
  @media (orientation: portrait) and (max-width: 600px) {
    min-height: 55vh;
  }
  width: 100%;
  margin: 1rem auto 0;
  background-color: var(--site-background);
  .slider-wrapper {
    max-width: 500px;
    margin: 0 auto 6rem;
    h3 {
      font-size: 2.2rem;
      line-height: 2.8rem;
      margin-bottom: 3rem;
      @media only screen and (max-width: 600px) {
        padding: 0 2rem;
      }
    }
    .displayer {
      font-size: 2rem;
      font-weight: 600;
      width: 100%;
      text-align: center;
    }
    .avatar-chooser {
      display: grid;
      grid-template-columns: 4fr 1fr 4fr;
      @media only screen and (max-width: 711px) {
        grid-template-columns: 4fr 1.5fr 4fr;
      }
      align-items: center;
    }
    .prev {
      text-align: right;
      padding-right: 2rem;
      cursor: pointer;
      border: none;
      outline: none;
    }
    .next {
      text-align: left;
      padding-left: 2rem;
      cursor: pointer;
      border: none;
      outline: none;
    }
    .avatar {
      width: 100%;
      text-align: center;
      margin-bottom: 1rem;
      border: none;
      -moz-user-select: none;
      -webkit-user-select: none;
      user-select: none;
    }
    .sliderWrapper {
      padding: 0 10%;
      @media only screen and (max-width: 599px) {
        padding: 0 15%;
      }
    }
    //slider button
    input[type='range']::-webkit-slider-thumb {
      background: var(--slider-knob) !important;
    }
    input[type='range']::-webkit-slider-runnable-track {
      background: var(--slider-track) !important;
    }
    /* All the same stuff for Firefox */
    input[type='range']::-moz-range-thumb {
      background: var(--slider-knob) !important;
    }
    input[type='range']::-moz-range-runnable-track {
      background: var(--slider-track) !important;
    }
    /* All the same stuff for IE */
    input[type='range']::-ms-thumb {
      background: var(--slider-knob) !important;
    }
    input[type='range']::-ms-runnable-track {
      background: var(--slider-track) !important;
    }
  }
`

const AvatarHint = styled.div`
  position: absolute;
  width: 100%;
  max-width: 100%;
  left: 0;
  margin-top: -43px;
  margin-left: 100vw; // is set via JS
  div {
    line-height: 2rem;
    font-size: 1.3rem;
  }
`

const YearHint = styled.div`
  position: absolute;
  left: 0; // is set via JS
  margin-top: 40px;
  margin-left: 20px;
  @media only screen and (max-width: 600px) {
    margin-left: 30px;
  }
  div {
    line-height: 2rem;
    font-size: 1.3rem;
  }
`

const ScrollHint = styled.div`
  font-size: 6rem;

  p {
    margin: 2rem 0 0;
    font-size: 1.8rem;
  }

  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(2.4rem);
    }
    100% {
      transform: translatey(0px);
    }
  }

  svg {
    color: var(--hint-arrow);
    margin: -1rem 0 2rem;
    transform: translatey(0px);
    animation: float 4s ease-in-out infinite;
  }
`

export default AgeInput
